// removed by extract-text-webpack-plugin
module.exports = {"searchBox":"jZrDb17sYQ20Ecrcl_FQB","searchContainer":"_3F9VaeZjxhvk1b9DwgLMvx","searchLogo":"_2Ny2jgM7A1O77nWnoEypwD","mainSearch":"_186lOrd9ZkVyMEBulsUd8Y","leftLogo":"k0NbmrhI1y_47L5LITLwb","removeFilter":"_20BgXLwIytr8N3EOnQay_p","cross":"mrUXVIV_GIUovc5f8decI","noResults":"_34iNfaHgp83l9mzWNdxXkz"};


//////////////////
// WEBPACK FOOTER
// ./elements/SearchBox.scss
// module id = 503
// module chunks = 0